import { useFlags } from "launchdarkly-react-client-sdk";
import { PageSpinner } from "src/components/loading";
import { useResourcePermission } from "src/components/permission/use-resource-permission";
import { useUser } from "src/contexts/user-context";
import { isPermissionsTabAccessible } from "src/events/permissions-tab-access";
import { Navigate, useLocation } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

import { useEventDestinationRouteContext } from "./destination/use-route-context";

const EventDestinationPermissions = lazyNamed(
  () => import("./destination/grants"),
  "EventDestinationPermissions",
);

export const EventDestinationPermissionsRoute = () => {
  const location = useLocation();
  const { user } = useUser();
  const { eventsRbacEnabled } = useFlags();
  const { context, isLoading } = useEventDestinationRouteContext();
  const permission =
    context == null
      ? undefined
      : context.type === "warehouse"
        ? {
            v2: {
              resource: "event_warehouse_destination" as const,
              grant: "can_update" as const,
              id: context.destination.id,
            },
          }
        : {
            v2: {
              resource: "event_forwarding_destination" as const,
              grant: "can_update" as const,
              id: context.destination.id,
            },
          };
  const permissions = useResourcePermission(permission, {
    enabled: Boolean(context?.destination.id),
  });
  const showPermissions = isPermissionsTabAccessible({
    eventsRbacEnabled,
    resource: context?.destination,
    user,
    permissions,
  });

  if (!eventsRbacEnabled) {
    return (
      <Navigate
        to={{ pathname: "../configuration", search: location.search }}
        relative="path"
        replace
      />
    );
  }

  if (isLoading || permissions.isLoading) {
    return <PageSpinner />;
  }

  if (!context || !showPermissions) {
    return (
      <Navigate
        to={{ pathname: "../configuration", search: location.search }}
        relative="path"
        replace
      />
    );
  }

  return <EventDestinationPermissions />;
};
